import React, { Component } from 'react'
import './performance-report.scss'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import { getImageSource } from '../../../utility/image-source'
import { ImageConstants } from '../../../constants/constants'
import moment from 'moment'

class PerformaceReport extends Component {
  state = {
    eventStudents: [],
    meta: { totalPages: 1, page: 1 },
    isLoading: false,
    selectedPage: 1
  }
  limit = 10;
  currentPage = 1;
  startIndex = 1;
  filter = {}
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
    this.getEventStudentPerformanceList(payload)
  }

  getEventStudentPerformanceList = (payload = {}) => {
    const {event} = this.props
    payload.eventId = event._id
    this.setState({
      isLoading: true
    })
    if (!payload.page) payload.page = 1
    if (!payload.limit) payload.limit = this.limit
    this.currentPage = payload.page

    if (this.currentPage === 1) this.startIndex = 1

    SchoolUserApi.getEventStudentPerformanceList(payload)
      .then(result => {
        this.setState({
          eventStudents: result.response,
          meta: result.meta,
          isLoading: false
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  onFilterGo = (payload = {}) => {
    this.filter = payload
    this.getEventStudentPerformanceList(this.filter)
  }

  onPageSelected = (selectedPage, startIndex) => {
    this.startIndex = startIndex
    this.filter.page = selectedPage
    this.setState({ selectedPage })
    this.getEventStudentPerformanceList(this.filter)
  }

  render() {
    const { eventStudents } = this.state
    return (
      <>
        <div id='table-scoll' className='table-responsive mt-5'>
          {this.state.isLoading && <Loading style={{ top: '100px' }}></Loading>}
          <div className='chart-title-legend ml-4'>
            <span className='skill-list'>
              <img
                className='skill-img'
                src={getImageSource(ImageConstants.KNOWLEDGE)}
              />
              <span className='skill-title'>Knowledge</span>
            </span>
            <span className='skill-list'>
              <img
                className='skill-img'
                src={getImageSource(ImageConstants.CALCULATION)}
              />
              <span className='skill-title'>Calculation</span>
            </span>
            <span className='skill-list'>
              <img
                className='skill-img'
                src={getImageSource(ImageConstants.MODELING)}
              />
              <span className='skill-title'>Modeling</span>
            </span>
            <span className='skill-list'>
              <img
                className='skill-img'
                src={getImageSource(ImageConstants.COMPREHENSION)}
              />
              <span className='skill-title'>Comprehension</span>
            </span>
          </div>
          <table className='table cw-table mb-0 align-items-center student-list'>
            <thead>
              <tr>
                <th className='text-center th-left-radius'>Sr no</th>
                <th className='text-center'>Student</th>
                <th className='text-center'>Score</th>
                <th className='text-center'>Time</th>
                <th className='text-center th-right-radius col-legends' colSpan='4'>
                  Skills
                  <div className="col-floating-legends">
                    <div className='row reset-row-margin'>
                      <div className="col-3 text-center">
                        <img
                          className='skill-img'
                          src={getImageSource(ImageConstants.KNOWLEDGE)}
                        />
                      </div>
                      <div className="col-3 text-center">
                        <img
                          className='skill-img'
                          src={getImageSource(ImageConstants.CALCULATION)}
                        />
                      </div>
                      <div className="col-3 text-center">
                        <img
                          className='skill-img'
                          src={getImageSource(ImageConstants.MODELING)}
                        />
                      </div>
                      <div className="col-3 text-center">
                        <img
                          className='skill-img'
                          src={getImageSource(ImageConstants.COMPREHENSION)}
                        />
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className='bg-white'>
              {eventStudents.length > 0 &&
                eventStudents.map((student, index) => (
                  <tr key={index} className='mt-4'>
                    <td className="text-center">{(index + 1) + ((this.currentPage - 1) * 10)}.</td>
                    <td className="text-center"><div className='name-text'>{student?.name}</div></td>
                    <td className="text-center"><strong>{student?.finalAssessmentMarkScored}</strong></td>
                    <td className="text-center"><strong>{moment.duration(student?.finalAssessmentTimeTaken).minutes()} m</strong></td>
                    <td className="text-center">
                      {student?.finalAssessmentKnowledgeCorrectPercentage}%
                    </td>
                    <td className="text-center">
                      {student?.finalAssessmentCalculationCorrectPercentage}%
                    </td>
                    <td className="text-center">
                      {student?.finalAssessmentModelingCorrectPercentage}%
                    </td>
                    <td className="text-center">
                      {student?.finalAssessmentComprehensionCorrectPercentage}%
                    </td>
                  </tr>
                ))}
              {!eventStudents.length && (
                <tr className='mt-4'>
                  <td colSpan='8' className='text-center'>
                    {' '}
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className='card-footer'>
            {
              !this.state.isLoading && this.state.meta.totalPages ?
                <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
            }
          </div>
        </div>
      </>
    )
  }
}

export default PerformaceReport
